import React, { FC, HTMLAttributes, Ref, useContext } from 'react';
import { ProductCarousel } from 'features/products-carousel';
import { Sections } from 'features/page-navigation/components/section-refs-context';
import { getComplements } from 'features/related-products/selectors';
import { cn } from 'utils';
import { AntifadeContainer } from 'common/components/section-vlimit/fade-container/fade-container';
import { pdpSectionStyle } from 'common/components/page-section';
import { APP_MAIN_ID } from 'common/constants';
import { Styles } from 'pages/product-details/styles';
import { withStoreLogic } from '../hocs/with-store-logic';

type ComplementGoodsMappedState = {
  products?: string[];
};

type ComplementGoodsProps = ComplementGoodsMappedState & HTMLAttributes<HTMLElement>;

/**
 * @internal Used only for tests
 */
export const ComplementGoods: FC<ComplementGoodsProps> = ({ products = [], className, id }) => {
  const ref = useContext(Sections.Context).get('complements') ?? undefined;

  const renderContent = products.length > 0;

  return (
    <>
      {renderContent && (
        <section
          ref={ref as Ref<HTMLDivElement>}
          className={cn(className, pdpSectionStyle)}
          id={id}
          data-qa={id}
        >
          <AntifadeContainer />
          <ProductCarousel
            className={Styles.pdpSectionInsideInfoBlockStyle}
            carouselId={id}
            products={products}
            title={'С этим товаром покупают'}
            portalRootId={APP_MAIN_ID}
          />
        </section>
      )}
    </>
  );
};

export const PdpComplementGoods = withStoreLogic(ComplementGoods, getComplements);
